import React, { useState, useEffect, useMemo } from "react"
import APIs from "redux/apis"
import { get } from "lodash"
import { pageLoadRegist } from "redux/ducks/PageLoad"
import { useDispatch } from "react-redux"
import { TrustTemplate } from "components/templates/domestic"
import uuid from "uuid"
import { LoadStateType } from "redux/ducks/PageLoad"
import { useSelector } from "react-redux"

export const Trust = () => {
  const [currentContent, changeContent] = useState<number>(0)
  const [data, setData] = useState([{}])
  const [Exchange, setExhange] = useState<1 | 3>(1)
  const [symbolMarginData, setSymbolMarginData] = useState({})
  const [contentFlag, changeContentFlag] = useState(false)
  const [refreshFlag, setRefreshFlag] = useState(false)
  const loadResistId = useMemo(() => uuid(), [])
  const isPageLoading = useSelector(
    (state: { PageLoad: LoadStateType }) => state.PageLoad.load
  )
  const dispatch = useDispatch()

  const requestApi = async () => {
    let _data
    dispatch(pageLoadRegist(loadResistId, true))
    // const _symbolMarginData = await APIs.SymbolDetail.SymbolInfoMargin({
    //   SecurityType: 1,
    //   Symbol: 7203,
    //   Exchange: 1,
    // })
    // console.log("_symbolMarginData", _symbolMarginData)
    // setSymbolMarginData(_symbolMarginData)
    switch (currentContent) {
      case 0:
        _data = await APIs.SymbolDetail.SyoukinZan()
        const resultList = get(_data, "ResultList", [{}])[0]
        const stockShort =
          get(resultList, "KashikabuZan") - get(resultList, "YuushiZan")
        const buy =
          get(resultList, "KashikabuShinki") + get(resultList, "YuushiHensai")
        const sell =
          get(resultList, "KashikabuHensai") + get(resultList, "YuushiShinki")
        setData({ ...resultList, stockShort, buy, sell })
        dispatch(pageLoadRegist(loadResistId, false))
        break
      case 1:
        _data = await APIs.SymbolDetail.GetMarginRemainMarket()
        setData(get(_data, "ResultList", [{}]))
        dispatch(pageLoadRegist(loadResistId, false))
        break
      case 2:
        _data = await APIs.SymbolDetail.GyakuHibu({
          Exchange,
        })
        setData(get(_data, "ResultList", [{}]))
        dispatch(pageLoadRegist(loadResistId, false))
        break
      case 3:
        _data = await APIs.SymbolDetail.GetStockShortage({
          Exchange,
        })
        setData(get(_data, "ResultList", [{}]))
        dispatch(pageLoadRegist(loadResistId, false))
        break
      case 4:
        // _data = await APIs.SymbolDetail.SyoukinZan()
        dispatch(pageLoadRegist(loadResistId, false))
        break
      default:
        dispatch(pageLoadRegist(loadResistId, false))
        break
    }
  }
  useEffect(() => {
    requestApi()
  }, [currentContent, Exchange])

  //ページ更新
  useEffect(() => {
    if (isPageLoading) requestApi()
  }, [isPageLoading])

  useEffect(() => {
    if (refreshFlag) {
      requestApi()
      setRefreshFlag(false)
    }
  }, [refreshFlag])

  return (
    <TrustTemplate
      data={data}
      currentContent={currentContent}
      changeContent={changeContent}
      setExchange={setExhange}
      exchange={Exchange}
      contentFlag={contentFlag}
      changeContentFlag={changeContentFlag}
      setRefreshFlag={setRefreshFlag}
    />
  )
}
